import { render, staticRenderFns } from "./knowledgeCategoryCard.vue?vue&type=template&id=5cbbfd22&"
import script from "./knowledgeCategoryCard.vue?vue&type=script&lang=js&"
export * from "./knowledgeCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports